import Vue from 'vue'
import { abilitiesPlugin } from '@casl/vue'
import ability from '../services/lck-abilities'

Vue.use(abilitiesPlugin, ability)
